import React, { useState, memo, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, Clock, Phone, MapPin, ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function CTASection() {
  const {
    t,
    language
  } = useLanguage();
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const faqs = [{
    q: t('cta', 'q1'),
    a: t('cta', 'a1')
  }, {
    q: t('cta', 'q2'),
    a: t('cta', 'a2')
  }, {
    q: t('cta', 'q3'),
    a: t('cta', 'a3')
  }, {
    q: t('cta', 'q4'),
    a: t('cta', 'a4')
  }, {
    q: t('cta', 'q5'),
    a: t('cta', 'a5')
  }];
  return <div id="contacto" data-id="element-51">
      {/* Risk Free Section */}
      <section className="py-20 bg-gold text-white" data-id="element-52">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-53">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-54">
            <Shield className="w-16 h-16 mx-auto mb-6 text-white/90" data-id="element-55" />
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-56">
              {t('cta', 'riskTitle')}
            </h2>
            <div className="space-y-4 text-lg text-white/90 mb-10" data-id="element-57">
              <p data-id="element-58">{t('cta', 'riskP1')}</p>
              <p className="font-medium text-white" data-id="element-59">{t('cta', 'riskP2')}</p>
              <p data-id="element-60">{t('cta', 'riskP3')}</p>
              <p data-id="element-61">{t('cta', 'riskP4')}</p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Urgency & Contact Section */}
      <section className="py-24 bg-beige-light" data-id="element-62">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-64">
            {/* Contact Info */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-65">
              <div className="flex items-center space-x-3 mb-6 text-gold-dark" data-id="element-66">
                <Clock className="w-6 h-6" data-id="element-67" />
                <h3 className="text-xl font-bold uppercase tracking-wider" data-id="element-68">
                  {t('cta', 'urgencyTitle')}
                </h3>
              </div>
              <p className="text-lg text-dark/80 mb-8" data-id="element-69">
                Lorena y su equipo de esteticistas trabajan por medio de citas,
                porque cada clienta recibe atención completamente personalizada.
                Somos un espacio de transformación.
              </p>

              <div className="bg-white p-8 rounded-sm shadow-lg border border-gold/20" data-id="element-70">
                <h3 className="text-2xl font-serif font-bold text-dark mb-6 text-center" data-id="element-71">
                  {t('cta', 'nextStep')}
                </h3>

                <div className="space-y-6 mb-8" data-id="element-72">
                  <div className="flex items-center justify-center space-x-4" data-id="element-73">
                    <Phone className="w-6 h-6 text-gold" data-id="element-74" />
                    <div className="text-xl font-medium text-dark" data-id="element-75">
                      <p data-id="element-76">(347) 264-8498</p>
                      <p data-id="element-77">(917) 396-4125</p>
                    </div>
                  </div>

                  <div className="flex items-center justify-center space-x-4 text-center" data-id="element-78">
                    <MapPin className="w-6 h-6 text-gold flex-shrink-0" data-id="element-79" />
                    <p className="text-dark/80" data-id="element-80">
                      32-60 84th St, East Elmhurst, NY 11370
                      <br data-id="element-81" />
                      Queens, New York
                    </p>
                  </div>
                </div>

                <motion.a href={`https://wa.me/13472648498?text=${encodeURIComponent(language === 'es' ? 'Hola Lorena, me gustaría agendar una cita.' : 'Hi Lorena, I would like to book an appointment.')}`} target="_blank" rel="noopener noreferrer" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="block w-full bg-gold hover:bg-gold-dark text-white py-4 rounded-sm font-bold text-lg transition-colors shadow-md uppercase tracking-wide text-center" data-id="element-82">
                  {t('cta', 'bookBtn')}
                </motion.a>
                <p className="text-center text-sm text-dark/50 mt-4 italic" data-id="element-83">
                  {t('cta', 'memory')}
                </p>
              </div>
            </motion.div>

            {/* FAQ */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-84">
              <h3 className="text-3xl font-serif font-bold text-dark mb-8" data-id="element-85">
                {t('cta', 'faqTitle')}
              </h3>
              <div className="space-y-4" data-id="element-86">
                {faqs.map((faq, index) => <div key={index} className="bg-white border border-gold/20 rounded-sm overflow-hidden" data-id="element-87">
                    <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-88">
                      <span className="font-bold text-dark" data-id="element-89">{faq.q}</span>
                      <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-90" />
                    </button>
                    <AnimatePresence data-id="element-91">
                      {openFaq === index && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3
                  }} data-id="element-92">
                          <div className="px-6 pb-4 text-dark/70 border-t border-gold/10 pt-2" data-id="element-93">
                            {faq.a}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}